import React, { useEffect, useRef, useState } from 'react'
import { get } from 'lib/api'
import { useNavigate, useParams } from 'react-router-dom'
import toast from 'react-hot-toast'
import { AxiosError } from 'axios'
import { AppState } from 'store'
import { UserState } from 'lib/types/models'
import { useSelector } from 'react-redux'
import Lottie from 'react-lottie'
import animationData from '../../animations/connecting-2.json'
import Logo from '../../lib/images/logo-full.png'
import LogoWhite from './ttn.png'
import Placeholder from './2D1A7171.jpg'

const EventNew: React.FC = () => {
  const ref = useRef<HTMLDivElement>(null)
  const pageRef = useRef<HTMLDivElement>(null)

  const [loading, setLoading] = useState(false)
  const [event, setEvent] = useState<any | null>(null)

  const navigate = useNavigate()

  const user = useSelector<AppState, UserState>(({ user }) => user)

  const params = useParams()

  const { code } = params

  const fetchEvent = async () => {
    setLoading(true)

    try {
      const { data } = await get(`/event/get-event/${code}`)

      setEvent(data)

      if (!user.authenticated) {
        if (!data.eventOwnerId) {
          navigate(`/register?event=${code}`)

          return
        }

        if (!data.locked) {
          if (ref.current) {
            ref.current.style.opacity = '0'
          }

          setTimeout(() => {
            setLoading(false)

            setTimeout(() => {
              if (pageRef.current) {
                pageRef.current.style.opacity = '1'
              }
            })
          }, 50)

          return
        }

        if (data.locked) {
          navigate(`/login?event=${code}`)

          return
        }
      }

      if (user.authenticated) {
        if (!data.locked) {
          if (ref.current) {
            ref.current.style.opacity = '0'
          }

          setTimeout(() => {
            setLoading(false)

            setTimeout(() => {
              if (pageRef.current) {
                pageRef.current.style.opacity = '1'
              }
            })
          }, 50)

          return
        }

        navigate(`/login?event=${code}`)
      }
    } catch (e) {
      const error = e as AxiosError

      if (error.response) {
        if (error.response.status === 404) {
          navigate('/404')

          return
        }

        const data = error.response.data as {
          error: {
            status: number
            message: string
          }
        }

        toast.error(data.error.message)
      }
    }
  }

  const onClick = () => {
    if (pageRef.current) {
      pageRef.current.style.transitionDuration = '750ms'
    }

    setTimeout(() => {
      if (pageRef.current) {
        pageRef.current.style.opacity = '0'
      }

      setTimeout(() => {
        navigate(`/event-new/${code}/upload`)
      }, 700)
    })
  }

  useEffect(() => {
    if (!code) {
      return
    }

    fetchEvent()
  }, [code])

  if (loading) {
    return (
      <div
        className="flex flex-col items-center justify-center h-full opacity-0 transition-opacity duration-[250ms]"
        ref={ref}
      >
        <div className="w-full absolute top-[30px] left-0 flex justify-center">
          <img src={Logo} alt="logo" width={200} />
        </div>
        {/* @ts-ignore */}
        <Lottie
          options={{
            loop: true,
            autoplay: true,
            animationData,
          }}
          height={200}
          width={200}
        />

        <div className="text-[20px] leading-[1.6] text-dark-500 font-medium">
          Etkinlik ile bağlantı sağlanıyor
        </div>
      </div>
    )
  }

  return (
    <div
      className="h-full bg-[#000] text-white transition-opacity duration-[750ms] font-morebi"
      ref={pageRef}
      style={{ opacity: 1 }}
    >
      {event?.event_date && (
        <div className="flex justify-end p-[20px]">
          <div
            className="flex flex-col items-center justify-center w-[60px] h-[60px] text-white font-bold"
            style={{
              background:
                'radial-gradient(circle at 100% 100%, #000000 0, #000000 14px, transparent 14px) 0% 0%/15px 15px no-repeat, radial-gradient(circle at 0 100%, #000000 0, #000000 14px, transparent 14px) 100% 0%/15px 15px no-repeat, radial-gradient(circle at 100% 0, #000000 0, #000000 14px, transparent 14px) 0% 100%/15px 15px no-repeat, radial-gradient(circle at 0 0, #000000 0, #000000 14px, transparent 14px) 100% 100%/15px 15px no-repeat, linear-gradient(#000000, #000000) 50% 50%/calc(100% - 2px) calc(100% - 30px) no-repeat, linear-gradient(#000000, #000000) 50% 50%/calc(100% - 30px) calc(100% - 2px) no-repeat, linear-gradient(0deg, transparent 0%, rgba(214,255,0,0.3) 100%)',
              borderRadius: '15px',
              boxSizing: 'border-box',
            }}
          >
            <div className="text-[13px]">
              {new Date(event.event_date).toLocaleDateString('tr-TR', {
                month: 'long',
              })}
            </div>
            <div className="text-[26px] -mt-[8px]">
              {new Date(event.event_date).getDate()}
            </div>
          </div>
        </div>
      )}
      <div className="flex flex-col items-center text-center gap-1 mb-[40px]">
        <div className="text-[26px]">Merhaba</div>
        <div className="text-[28px] leading-[28px] font-bold">
          {event?.name}
        </div>
        <div className="text-[15px] font-light opacity-50">
          Zaman Kapsülüne Hoş Geldiniz.
        </div>
      </div>
      <div className="px-[50px] h-[250px]">
        <img
          src={event?.avatar || Placeholder}
          alt=""
          className="w-full h-full object-cover rounded-[20px]"
        />
      </div>
      <div className="px-[20px] mt-[40px]">
        <div
          onClick={onClick}
          className="bg-[#D6FF00] text-[#000] rounded-full h-[55px] text-[16px] leading-[24px] flex w-full items-center justify-center"
        >
          Etkinliğe Katılın
        </div>
      </div>
      <div className="flex flex-col items-center mt-[20px]">
        <div className="text-[15px] opacity-50">Bu bir</div>
        <img src={LogoWhite} alt="logo" />
        <div className="text-[15px] opacity-50">etkinliğidir</div>
      </div>
    </div>
  )
}

export default EventNew
